var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"orderList"}},[_c('ul',_vm._l((_vm.orders),function(order){return _c('li',{key:order.id},[_c('span',[_vm._v("ID："+_vm._s(order.id))]),_c('span',[_vm._v("类型："+_vm._s(order.type))]),_c('span',[_vm._v("内容："+_vm._s(order.content))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }